import { StoreState } from '@/core/models/store.interface';
import { LocationQuery } from 'vue-router';
import { Module } from 'vuex';
import { JointCommittee, JointCommitteeWorkerStatute } from './joint-committee.interface';
import { JointCommitteeService } from './joint-committee.service';

const service = new JointCommitteeService();

export interface JointComitteeState {
   userJointCommittees: JointCommittee[];
   companyJointCommittees: JointCommittee[];
   fulltimesCompanyJointCommittees: JointCommittee[];

   jointCommittees: JointCommittee[];
   jointCommitteeWorkerStatutes: Array<JointCommitteeWorkerStatute>;
}

const JointCommitteeStore: Module<JointComitteeState, StoreState> = {
   namespaced: true,
   state: {
      userJointCommittees: [],
      companyJointCommittees: [],
      fulltimesCompanyJointCommittees: [],

      jointCommittees: [],
      jointCommitteeWorkerStatutes: [],
   },
   getters: {
      jointCommittees(state) {
         return state.jointCommittees || [];
      },
   },
   mutations: {
      SET_JOINT_COMMITTEES(state, jointCommittees: Array<JointCommittee>) {
         state.jointCommittees = jointCommittees;
      },
      SET_JOINT_COMMITTEE_WORKER_STATUTES(state, jcws: Array<JointCommitteeWorkerStatute>) {
         state.jointCommitteeWorkerStatutes = jcws;
      },
      setUserJointCommittees(state: any, newValue: any) {
         state.userJointCommittees = newValue;
      },
      setCompanyJointCommittees(state: any, newValue: any) {
         state.companyJointCommittees = newValue;
      },
      setFulltimesCompanyJointCommittees(state: any, newValue: any) {
         state.fulltimesCompanyJointCommittees = newValue;
      },
      deleteJointCommitteeState(state: any, item: any) {
         state[item.key] = item.value;
      },
   },
   actions: {
      async getJointCommittees(context: any, query?: LocationQuery) {
         const response = await service.getJointCommittees(query);
         context.commit('SET_JOINT_COMMITTEES', response.data);
         return response;
      },
      async getJointCommitteeByNumber(context: any, number: number) {
         return await service.getJointCommitteeByNumber(number).then((response: any) => response.data);
      },
      async createNewCompanyJointCommittee(context: any, { companyId, jointCommitteeNumber }: any) {
         return await service.postCompanyJointCommittees(companyId, jointCommitteeNumber);
      },
      async deleteCompanyJointCommittee(context: any, { companyId, jointCommitteeNumber }: any) {
         return await service.deleteCompanyJointCommittees(companyId, jointCommitteeNumber);
      },
      async getJointCommitteesByCompanyId(context: any, companyId: number) {
         return await service.getJointCommitteeByCompanyID(companyId).then((response) => {
            context.commit('setCompanyJointCommittees', response);
            return response;
         });
      },
      async getSetJointCommitteesByFulltimeCompanyId(context: any, companyId: any) {
         return await service.getJointCommitteeByCompanyID(companyId).then((response) => {
            context.commit('setFulltimesCompanyJointCommittees', response);
         });
      },
      async getJointCommitteeWorkerStatutes(context: any, query?: LocationQuery) {
         const response = await service.getJointCommitteeWorkerStatutes(query);
         context.commit('SET_JOINT_COMMITTEE_WORKER_STATUTES', response);
         return response;
      },
   },
};

export default JointCommitteeStore;
